<template>
  <section>
    <h2 class="h2Title">분류 관리</h2>
    <div class="dashWrap">
      <div class="dashRow">
        <div class="dashBx">
<!--        <h2 class="tit">분류 목록</h2>-->

          <tree
              ref="groupTree"
              :data="treeData"
              :options="treeOptions"
              @node:clicked="getGroup"
              @node:dragging:finish="moveGroup">

            <span class="tree-text" slot-scope="{ node }">
              <template v-if="!node.hasChildren()">
                <i :class="[node.data.activated ? 'fa fa-check-circle' : 'fa fa-ban']"></i>
                {{ node.text }}
              </template>

              <template v-else>
                <i :class="[node.data.activated ? 'fa fa-check-circle' : 'fa fa-ban']"></i>
                {{ node.text }}
              </template>

            </span>

          </tree>

        </div>
        <div class="btnStyleBx">
          <div class="btnCommon justify-center">
            <v-btn class="vIconResize" @click="createGroupForm">
              <v-icon left>mdi mdi-playlist-plus</v-icon> 분류 추가
            </v-btn>
          </div>
        </div>
      </div>


      <!--      분류 상세-->
      <div class="dashRow">
        <div class="dashBx">
          <v-tabs>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#tab-1">
              <v-icon>mdi-note</v-icon>
              {{ group.groupName }} 상세
            </v-tab>

            <v-tab href="#tab-2">
              <v-icon>mdi-account</v-icon>
              {{ group.groupName }} 회원
            </v-tab>

            <v-tab href="#tab-3">
              <v-icon>mdi-account-supervisor</v-icon>
              {{ group.groupName }} 역대 위원장 / 간사
            </v-tab>


            <v-tab-item value="tab-1" key="1">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
                <span>분류 상세 설정</span>
              </h2>
              <group-detail
                  :item="group"
                  :items="groups"
                  :modify="isModify"
                  :parent="parent"
                  @callback-saved="savedGroup"
                  @callback-deleted="deletedGroup"/>
            </v-tab-item>
            <v-tab-item value="tab-2" key="2">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
                <span>{{ group.groupName }} 회원 목록</span>
              </h2>
              <user-list :group="group"></user-list>
            </v-tab-item>
            <v-tab-item value="tab-3" key="3">
              <h2 class="tit arrowLink d-flex align-center justify-space-between">
                <span>역대 위원장 / 간사 목록</span>
              </h2>
              <generation-leader :group="group" />
            </v-tab-item>
          </v-tabs>
        </div>
      </div>

    </div>

  </section>
</template>

<script>
import _ from 'lodash';
import LiquorTree from 'liquor-tree';
// import {ValidationProvider} from 'vee-validate';

import groupApi from '@/api/GroupApi';

import GroupDetail from "./GroupDetail";
import UserList from "./UserList";
import GenerationLeader from "./GenerationLeader"


async function loadTreeData() {
  let temp = await groupApi.list();
  // console.log(temp);
  temp.forEach(t => genTree(t, 1));

  return temp;
}
const genTree = (item, depth) => {
  item.data = genDataStruct(item);
  // if(depth >= 3) {
  //   item.options = {dropable: false};
  // }
  item.childGroups?.forEach(t => genTree(t, depth+1));
}

function genDataStruct(obj) {
  return {
    groupId : obj.groupId,
    groupName : obj.groupName,
    activated : obj.activated
  }
}

export default {
  name: 'Group',
  components: {
    [LiquorTree.name]: LiquorTree,
    'group-detail' : GroupDetail,
    'user-list' : UserList,
    'generation-leader' : GenerationLeader
  },
  data: () => ({
        treeData: loadTreeData(),
        treeOptions: {
          parentSelect: true,
          propertyNames: {
            state: 'options',
            text: "groupName",
            children: "childGroups"
          },
          dnd:true
        },
        group: {},
        parent: null,
        groups: [],
        chart: {},
        isModify: false,
        flagChartEdit: false,
        treeItem: null,
        addedChart: null,
        editedChart: null,
        deletedChartKey: null
      }
  ),
  methods: {
    async getGroup(node) {
      // node.toggleExpand();

      if(node.states.selected) {
        await node.select(false);
        node.unselect();

        this.treeItem = null;
        this.group = {};
        this.parent = null;
        this.isModify = false;

      } else {

        this.treeItem = node;
        this.group = await groupApi.getGroup(node.data.groupId);
        this.parent = _.cloneDeep(this.group);
        this.isModify = true;

      }
    },
    async createGroupForm() {
      this.group = {};
      this.isModify = false;
    },
    async savedGroup(c) {
      // console.log(c);
      // console.log(this.flatList(this.$refs.groupTree.findAll().tree.model));

      if(this.flatList(this.$refs.groupTree.findAll().tree.model).map(t => t.data.groupId).includes(c.groupId)) {

        this.treeItem.data.groupName = c.groupName;
        this.treeItem.data.activated = c.activated;
        this.treeItem.text = c.groupName;

      } else {

        let item = {
          text: c.groupName,
          data: {
            groupId: c.groupId,
            groupName: c.groupName,
            activated: c.activated,
            text: c.groupName
          },
          state: {selected: false}
        };

        if(c.parentId) {
          // let node = this.$refs.groupTree.tree.parse(item);
          // let parent = this.$refs.groupTree.findAll().tree.model.filter(t => t.data.groupId === c.parentId)?.[0];
          // console.log(this.$refs.groupTree.tree.loadChildren());
          // this.$refs.groupTree.tree.loadChildren().then(d => {
          //   console.log(d);
          // })
          // console.log(parent);
          // parent.children.push(node[0]);
          // console.log(parent);

          this.treeItem.states.expanded = true;
          const parentNode = this.$refs.groupTree.find({
            data: {
              groupId: c.parentId
            }
          })[0];

          this.treeItem = this.$refs.groupTree.append(parentNode, item);
        } else {
          // this.treeItem = this.$refs.groupTree.append(item);
          this.treeItem = this.$refs.groupTree.append(item);
        }
      }

      this.group = await groupApi.getGroup(c.groupId);
      this.isModify = true;

    },
    deletedGroup() {
      this.group = {};
      this.parent = null;
      this.treeItem.remove();
      this.isModify = false;
    },
    async moveGroup(moveNode, destinationNode, pos) {
      let position = new Map();
      position.set('DRAG-ABOVE', 'up');
      position.set('DRAG-BELOW', 'down');
      position.set('DRAG-ON', 'in');

      await groupApi.moveGroup(moveNode.data.groupId, destinationNode.data.groupId, position.get(pos.toUpperCase()));
    },
    flatList(items) {
      if(items && items.length > 0) {
        return items.flatMap(i => {

          if(i.children && i.children.length > 0) {
            return [this.flatList(i.children), i].flatMap(i=>i);
          } else {
            return [i]
          }

        });
      } else
        return [];
    }

  },
  async created() {
    this.groups = await this.treeData;
  }

}
</script>


<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}


.dashWrap {
  display: flex;
  flex-flow: row wrap;
}

.dashRow:first-child {
  flex: 0 1 20%;

  &:first-child {
    margin-right: 2%;
  }
}
.dashRow:nth-child(2) {
  flex: 0 1 75%;

}
.tit {
  margin-top: 30px;
  margin-left: 5px;
  margin-bottom: 10px;
  font-size: 18px;
}

.dashBx {
  padding: 20px;
  border: 1px solid #e9e9e9;

  .state {
    padding-top: 37px;
    padding-bottom: 37px;
    cursor: pointer;
    color: #666;

    dt {
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 20px;

      em {
        margin-right: 5px;
        font-size: 50px;
        font-weight: bold;
        color: #333;
      }
    }

    dd {
      font-weight: 500;
    }
  }

  .deposit {
    display: flex;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      flex: 0 0 38%;

      &:nth-child(3) {
        flex: 0 0 24%;
      }

      .depositTit {
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 25px;
        background: #f6f6f6;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      }

      .depositNum {
        display: flex;
        padding-top: 50px;
        padding-right: 30px;

        p {
          margin-right: 50px;

          em {
            font-size: 40px;
            font-weight: bold;
          }
        }
      }
    }
  }

}

.h3Title {
  @include h3-title;
}
.tabContent{
  .formInfo {
    @include form-info;
  }
  .formInfoArea{
    &.align-normal{
      align-items: normal !important;
    };
    padding: 10px 10px 0 0;
    font-size: 13px;
    font-weight: 600;
    &.small{
      flex: 0 0 130px;
      width: 130px;
    }

  }
  .list{
    display: flex;
    width: 100% !important;
    img{
      width: 100%;
      height: auto;
    }
  }
  .wh300{
    width: 300px;
    padding: 0;
  }
}
</style>